import React, { useId, useSyncExternalStore } from 'react';
import { Moon, Sun } from 'lucide-react';
import { getLanguage, t } from '../i18n';
import { DEFAULT_THEME, getTheme, setTheme, subscribeToTheme } from '../services/ThemeService';
import './ThemeSelector.css';

const getServerTheme = () => DEFAULT_THEME;

export default function ThemeSelector({ language = getLanguage(), disabled = false }) {
  const theme = useSyncExternalStore(subscribeToTheme, getTheme, getServerTheme);
  const labelId = useId();
  const hintId = useId();
  return (
    <div className="theme-selector" role="group" aria-labelledby={labelId} aria-describedby={hintId}>
      <span className="theme-selector-label" id={labelId}>{t('theme.label', language)}</span>
      <div className="theme-selector-options">
        {[{ value: 'light', Icon: Sun }, { value: 'dark', Icon: Moon }].map(({ value, Icon }) => (
          <button type="button" key={value} className="theme-selector-option" aria-pressed={theme === value}
            disabled={disabled} onClick={() => setTheme(value)}>
            <Icon size={18} aria-hidden="true" />
            <span>{t(`theme.${value}`, language)}</span>
          </button>
        ))}
      </div>
      <p className="theme-selector-hint" id={hintId}>{t('theme.deviceHint', language)}</p>
    </div>
  );
}
